import { render, staticRenderFns } from "./integral-submit.vue?vue&type=template&id=1820785b&scoped=true&"
import script from "./integral-submit.vue?vue&type=script&lang=js&"
export * from "./integral-submit.vue?vue&type=script&lang=js&"
import style0 from "./integral-submit.vue?vue&type=style&index=0&id=1820785b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1820785b",
  null
  
)

export default component.exports